import React from "react"
import {useState} from "react";
import {Spin} from "antd"
import CrossDockItemContent from "./cross-dock-item-content";

import { CROSS_DOCK_DRAFT, CROSS_DOCK_AGREED, CROSS_DOCK_IN_CALCULATION } from "../../helpers/cross_dock_status.helper";

export default function CrossDockItemBlock({
                                            crossDock,
                                            setNeedUpdate,
                                            setStopListUpdate,
                                          }) {
  // Может быть позже скрытый элемент для доп инфы нужен будет
  const [contentVisible, setContentVisible] = useState(false);

  let statusClass = '';

  switch (crossDock.statusAlias) {

    case CROSS_DOCK_DRAFT:
      statusClass = ' application-item-red';
      break;
  
    case CROSS_DOCK_IN_CALCULATION:
      statusClass = ' application-item-blue';
      break;

    case CROSS_DOCK_AGREED:
      statusClass = ' application-item-green';
      break;

    default:
      statusClass = ' application-item-blue';
      break;
  }


  return (
    <div className={`application-item${statusClass}`}>
    <CrossDockItemContent crossDock={crossDock}
        setNeedUpdate={setNeedUpdate}
        setStopListUpdate={setStopListUpdate} />
    </div>
  )
}